import state from "./state";

const tokenAlias = btoa('token');
const roleAlias = btoa('role');

const getters = {
  token: (state: any): string => {
    return state.token ? state.token : localStorage[tokenAlias]
  },
  role: (state: any): string =>
    state.role ? state.role : localStorage[roleAlias],
  language: () => {
    const lang = localStorage.mlang;

    const navigatorLang = window.navigator.language == "zh-CN" ? "zh" : "en";

    const language = lang && lang !== "undefined" ? lang : navigatorLang;
    return language;
  },
  angleOfView: (state: any) => {
    return state.systemConfig?.angleOfView || 0
  },
  isMobile: () => {
    const ua: any = navigator.userAgent.toLowerCase();
    const bIsIpad = ua.match(/ipad/i) == "ipad";
    const bIsIphone = ua.match(/iphone/i) == "iphone";
    const bIsMidp = ua.match(/midp/i) == "midp";
    const bIsUc7 = ua.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    const bIsUc = ua.match(/ucweb/i) == "web";
    const bIsCE = ua.match(/windows ce/i) == "windows ce";
    const bIsWM = ua.match(/windows mobile/i) == "windows mobile";
    const bIsAndroid = ua.match(/android/i) == "android";

    if (
      bIsIpad ||
      bIsIphone ||
      bIsMidp ||
      bIsUc7 ||
      bIsUc ||
      bIsCE ||
      bIsWM ||
      bIsAndroid
    ) {
      return true;
    }
    return false;
  },
  isWeixin: () => {
    const ua: any = navigator.userAgent.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
  },
  isDingTalk: () => {
    const ua: any = navigator.userAgent.toLowerCase();
    return ua.match(/dingtalk/i) == "dingtalk";
  },
  isQYWeixin: () => {
    const ua: any = navigator.userAgent.toLowerCase();
    return (
      ua.match(/MicroMessenger/i) == "micromessenger" &&
      ua.match(/wxwork/i) == "wxwork"
    );
  },
  msgCount: (state: any) => {
    let count = 0;
    for (const key in state.countSum) {
      if (Object.prototype.hasOwnProperty.call(state.countSum, key)) {
        const num = state.countSum[key];
        if (num) {
          count = count + num;
        }
      }
    }
    return count
  },
};
export default getters;
